// Force non-empty content blocks under specific list-type section headers
// (e.g. PATIENT ACTIVE PROBLEM LIST) to render as unordered-list-item.
// Repairs stale DB data where some items were saved as `unstyled` (no bullet).
// Empty blocks are left unchanged so existing spacers stay as-is.
const SECTION_HEADERS_NEEDING_BULLETS = [
  "PATIENT ACTIVE PROBLEM LIST",
  "PAST MEDICAL HISTORY",
  "PAST SURGICAL HISTORY"
];

const isSectionHeader = (block) => {
  if (!block || !block.text || block.text.length === 0) return false;
  const ranges = block.inlineStyleRanges || [];
  const hasBold = ranges.some((r) => r && r.style === "BOLD");
  const hasUnderline = ranges.some((r) => r && r.style === "UNDERLINE");
  return hasBold && hasUnderline;
};

const normalizeSectionBullets = (dataMix) => {
  if (!dataMix || !dataMix.blocks || !Array.isArray(dataMix.blocks)) return dataMix;

  let currentSection = null;

  dataMix.blocks = dataMix.blocks.map((block) => {
    if (isSectionHeader(block)) {
      currentSection = block.text;
      return block;
    }
    if (!currentSection) return block;
    if (!SECTION_HEADERS_NEEDING_BULLETS.includes(currentSection)) return block;

    const text = (block && block.text) || "";
    if (!text || text.replaceAll(" ", "") === "") return block;
    if (block.type === "unordered-list-item") return block;
    if (block.type !== "unstyled") return block;

    return { ...block, type: "unordered-list-item" };
  });

  return dataMix;
};

export default normalizeSectionBullets;
